import { AdaaHelper } from "../../../../../../../core/utils";
import { SharedFields } from "../../configs";
import { ScreenSectionConfigType, ScreenType } from "../../wf-difference.types";

const cycleField: ScreenSectionConfigType = {
  view: "normal",
  field: "cycleId",
  label: "cycle.cycle",
  format: (value: Record<string, string>) => AdaaHelper.getItemValueByToken(value, "cycleName"),
};

const createdByField: ScreenSectionConfigType = {
  view: "normal",
  field: "createUser",
  label: "helpdesk.created_by",
  format: (value: Record<string, string>) => AdaaHelper.getItemValueByToken(value, "createUserName"),
};

const attachmentField: ScreenSectionConfigType = {
  view: "normal",
  field: "itemAttachmentId",
  label: "helpdesk.attachments",
  format: (value: Record<string, string>) => value.fileName,
  isClickable: true,
  isSimpleAttachment: true,
};

const approvedByField: ScreenSectionConfigType = {
  view: "normal",
  field: "publishUser",
  label: "common.form.label.approved_by",
  format: (value: Record<string, string>) => AdaaHelper.getItemValueByToken(value, "publishUserName"),
};

export const transformationalAgreementsScreenConfig = {
  type: "simple" as ScreenType,
  sections: [SharedFields.entityIdField, attachmentField, cycleField, createdByField, approvedByField],
};
